import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { formatUSD } from '@sparefoot/react-core/utils/format';

import { unitPropType } from 'config/propTypes';

import { FeeWarningToolTip } from 'components/unit/FeeWarningToolTip';

import { Paragraph, Text } from 'components/core/Typography';
import { Link } from 'components/core/Link';

import './NewStackedUnits.scss';
import { TrackingClient } from '@sparefoot/tracking-client';

export function NoUnits({ unit }) {
	return (
		<div className="stacked-no-units">
			<Paragraph
				size="smallMedium"
				weight="standard"
				color="placeholderGray"
				last
			>
				No{' '}
				<Text
					size="small"
					weight="extraBold"
					color="placeholderGray"
				>
					{unit.size}
				</Text>{' '}
				Units Available
			</Paragraph>
		</div>
	);
}

NoUnits.propTypes = {
	unit: unitPropType.isRequired,
};

export function NewStackedUnit({ unit, facility, baseUrl }) {
	if (unit?.quantity === 0) {
		return <NoUnits unit={unit} />;
	}

	const trackUnitSelect = () => {
		if (!unit) return;

		const location = facility?.location
			? `${facility.location.city}, ${facility.location.fullState}`
			: 'Unknown Location';

		TrackingClient.trackFacilityUnitSelected({
			facility: {
				id: facility?.id || 'Unknown Facility ID',
				name: facility?.name || 'Unknown Facility',
				location: location,
			},
			unit: {
				currency: 'usd',
				id: unit.id,
				variant_size: unit?.sizeText || 'Unknown Size',
				price: unit?.price?.meta || 'Unknown Price',
				quantity: 1,
			},
			unit_id: unit.id,
			unit_promo: unit.promotion || 'No Promo',
		});
	};

	return (
		<Link
			className="new-stacked-unit"
			href={`${baseUrl}${unit.url}`}
			rel="nofollow"
			onClick={trackUnitSelect}
			trackEcommerceClick
			ecommerceProps={{
				price: get(unit, 'price.meta', ''),
			}}
		>
			<div className="unit-container">
				<div className="unit">
					<Paragraph
						size="smallMedium"
						weight="standard"
						last
					>
						<Text
							size="small"
							weight="extraBold"
						>
							{unit.size}
						</Text>{' '}
						{unit.typeText}
					</Paragraph>
					{!!unit.special && (
						<Paragraph
							className="unit-promo"
							size="tiny"
							weight="medium"
							color="greenHero"
							last
						>
							{unit.special}
						</Paragraph>
					)}
				</div>
				{!unit.isOutOfBookingRange && (
					<div className="unit-price">
						<Paragraph
							size="medium"
							weight="extraBold"
							color="blue"
							last
						>
							{unit.quantity && unit.quantity < 4 && (
								<Text
									className="scarcity"
									size="small"
									weight="medium"
									color="blue"
								>
									{unit.quantity} left{' '}
								</Text>
							)}
							{formatUSD(unit.price.meta)}
						</Paragraph>
						{facility.showFeeWarning && facility.totalFees > 0 && (
							<FeeWarningToolTip
								facility={facility}
								className="fee-tooltip"
							/>
						)}
					</div>
				)}
			</div>
		</Link>
	);
}

NewStackedUnit.propTypes = {
	unit: unitPropType.isRequired,
	baseUrl: PropTypes.string,
	facility: PropTypes.object.isRequired,
};

export default NewStackedUnit;
